import { render, staticRenderFns } from "./DCIFeedBackSubmit.vue?vue&type=template&id=f0c06ee4&scoped=true"
import script from "./DCIFeedBackSubmit.vue?vue&type=script&lang=js"
export * from "./DCIFeedBackSubmit.vue?vue&type=script&lang=js"
import style0 from "./DCIFeedBackSubmit.vue?vue&type=style&index=0&id=f0c06ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c06ee4",
  null
  
)

export default component.exports